export default __webpack_public_path__ + "static/united_states_flag-38c2adbb6897414050e1a0c145b33e24.png";